<template>
    <div v-if="show.plan.canUpgrade">
        <base-loader v-if="!billingPlans" />
        <shows-message-box
            v-else
            key="message-box"
            class="shows-message-box"
            :class="{ 'compact': singleUpgradePlan }"
        >
            <template v-if="!singleUpgradePlan" v-slot:image>
                <img src="/images/player-image.png">
            </template>
            <template v-slot:content>
                <template>
                    <!-- eslint-disable-next-line vue/no-v-html -->
                    <h2 class="title" v-html="getTitle()" />
                    <p class="content">
                        {{ getDescription() }}
                        <a href="https://fusebox.fm/pricing/" target="_blank" class="learn-more">Learn more.</a>
                    </p>
                </template>
                <base-submit-button
                    class="btn is-green"
                    @click="handleUpgradeClick()"
                >
                    {{ getButtonText() }}
                </base-submit-button>
            </template>
        </shows-message-box>
    </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import { Step } from '@/utils/config/addShowModal';
import ShowsMessageBox from '@/components/Shows/ShowsMessageBox';

export default {
    components: {
        ShowsMessageBox,
    },

    props: {
        show: {
            type: Object,
            required: true,
        },
    },

    computed: {
        ...mapState([
            'billingPlans',
        ]),

        /**
         * Returns plan to upgrade if there is only one option available.
         *
         * @returns {object|null} Plan for eligible to upgrade or null.
         */
        singleUpgradePlan() {
            return this.billingPlans && 1 === this.show.plan.upgradePlans.length
                ? this.billingPlans.find(
                    ({ slug }) => slug === this.show.plan.upgradePlans[0]
                )
                : null;
        },
    },

    methods: {
        ...mapMutations(['changeUIState']),

        /**
         * Gets box title depending on the upgrade options.
         *
         * @returns {string} Box title.
         */
        getTitle() {
            return this.singleUpgradePlan
                ? `Upgrade to ${this.singleUpgradePlan.name} and unlock all that Fusebox has to offer!`
                : 'Get FREE podcast hosting by upgrading to the Starter plan!';
        },

        /**
         * Gets box description depending on the upgrade options.
         *
         * @returns {string} Box description.
         */
        getDescription() {
            return this.singleUpgradePlan
                ? `Like all the bells and whistles? Fusebox ${this.singleUpgradePlan.name} gives your podcasts the premium treatment!`
                : 'You’ll also unlock pro-level customization options to make the players blend seamlessly with your website!';
        },

        /**
         * Gets the button text depending on the upgrade options.
         *
         * @returns {string} Button text.
         */
        getButtonText() {
            return this.singleUpgradePlan
                ? `Upgrade to ${this.singleUpgradePlan.name}`
                : 'Upgrade to Starter';
        },

        /**
         * Handles uprade button click.
         */
        handleUpgradeClick() {
            this.changeUIState({
                addShowModal: {
                    visible: true,
                    show: this.show,
                    mode: 'upgrade',
                    plan: this.singleUpgradePlan,
                    type: this.show.hosted ? 'hosted' : 'feed',
                    step: Step.Plans,
                },
            });
        },
    },
};
</script>
